import { developmentPlanConstants } from '../../_constants';
import { developmentPlanService } from '../../_services';

export const getRelationList = {
    getRelationListHandler
};

function getRelationListHandler() {
    return dispatch => {
        dispatch(request());
        developmentPlanService.getRelationList()
            .then(
                RelationList => {
                    dispatch(success(RelationList));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: developmentPlanConstants.REQUEST_RELATION_LIST} }
    function success(RelationList) { return { type: developmentPlanConstants.RECEIVE_RELATION_LIST, RelationList } }
    function failure(error) { return { type: developmentPlanConstants.RELATION_LIST_ERROR, error } }
}



// WEBPACK FOOTER //
// ./src/_actions/DevelopmentPlan/getRelations.action.js